const initialState = () => ({
  filters: [
    {
      key: 'techs',
      active: false,
      label: 'All Technicians',
      options: [],
      activeOption: {},
    },
    {
      key: 'status',
      active: true,
      label: 'Account Status',
      options: [
        {
          label: 'Active',
          value: 'active',
        },
        {
          label: 'Deactivated',
          value: 'deactivated',
        },
        {
          label: 'Pending',
          value: 'Pending',
        },
      ],
      activeOption: {
        label: 'Active',
        value: 'active',
      },
    },
    {
      key: 'installDate',
      active: false,
      label: 'Install Date',
      options: [
        {
          label: 'Last 7 Days',
          value: 'lastWeek',
        },
        {
          label: 'Last 30 Days',
          value: 'lastMonth',
        },
        {
          label: 'Last 365 Days',
          value: 'lastYear',
        },
      ],
      activeOption: {},
    },
    {
      key: 'myTech',
      active: false,
      label: 'Video Chat On Call',
      options: [
        {
          label: 'Any',
          value: 'any',
        },
        {
          label: 'On',
          value: true,
        },
        {
          label: 'Off',
          value: false,
        },
      ],
      activeOption: {},
    },
  ],
  profileFilters: [
    {
      key: 'nameplate',
      active: false,
      label: 'Nameplate',
      options: [
        {
          label: 'Profiled',
          value: 'profiled',
        },
        {
          label: 'Not profiled',
          value: 'notProfiled',
        },
      ],
      activeOption: {},
    },
    {
      key: 'installDate',
      active: false,
      label: 'Install Date',
      options: [
        {
          label: 'Last Week',
          value: 'lastWeek',
        },
        {
          label: 'Last Month',
          value: 'lastMonth',
        },
        {
          label: 'Last Year',
          value: 'lastYear',
        },
      ],
      activeOption: {},
    },
  ],
  bulkBranchFilters: [
    {
      key: 'branch',
      active: false,
      label: 'Branch',
      options: [],
      activeOption: {},
      hideClear: false,
    },
  ],
  technicians: [],
  allTechnicians: [],
  selectedTech: {},
  actionModalView: '',
  showActionModal: false,
  corpOptions: [],
  imageForm: null,
  installations: [],
  parsingTechs: false,
  errorObj: {},
  newTechsUpload: [],
  partnerSettings: {},
});

export default initialState;
